'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _auth = require('redux/modules/auth');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _consoleColor = require('helpers/console-color');

var _responseCodes = require('helpers/responseCodes');

var _responseCodes2 = _interopRequireDefault(_responseCodes);

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _common = require('redux/modules/common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* API client middleware, catch API errors */

var ClientMiddleware = function () {
  function ClientMiddleware(_ref) {
    var client = _ref.client;
    (0, _classCallCheck3.default)(this, ClientMiddleware);

    this.client = client;
    this.promiseStore = {};
    this.dispatch = _noop3.default;
    this.getState = _noop3.default;
    this.next = _noop3.default;
    this.action = null;
  }

  (0, _createClass3.default)(ClientMiddleware, [{
    key: 'showToast',
    value: function showToast(_ref2) {
      var type = _ref2.type,
          message = _ref2.message;

      var _t = require('i18n-universal').getT();
      var translatedMessage = _t(message);
      if (__SERVER__) {
        this.dispatch((0, _common.setDelayedToast)({ type: type, message: translatedMessage }));
      } else {
        _toastr2.default[type](translatedMessage);
      }
    }
  }, {
    key: 'getUser',
    value: function getUser() {
      return (0, _get3.default)(this.getState(), 'auth.user');
    }
  }, {
    key: 'setParams',
    value: function setParams(_ref3) {
      var dispatch = _ref3.dispatch,
          getState = _ref3.getState,
          action = _ref3.action,
          next = _ref3.next;

      this.dispatch = dispatch;
      this.getState = getState;
      this.action = action;
      this.next = next;
    }
  }, {
    key: 'onResultPopup',
    value: function onResultPopup(_ref4) {
      var result = _ref4.result;
      var messageField = _config2.default.response.messageField;

      var message = result[messageField];
      var hidePopup = (0, _get3.default)(result, 'hidePopup');

      if (message && hidePopup === false) {
        this.showToast({ type: 'info', message: message });
      }
    }

    /* eslint-disable no-use-before-define */

  }, {
    key: 'onErrorPopup',
    value: function onErrorPopup(_ref5) {
      var error = _ref5.error;
      var _config$response = _config2.default.response,
          messageField = _config$response.messageField,
          statusField = _config$response.statusField;

      var message = (0, _get3.default)(error, ['response', 'body', messageField]) || error[messageField] || error.reason || error.toString();
      var hidePopup = (0, _get3.default)(error, 'hidePopup');
      var hideErrors = (0, _get3.default)(error, 'hideErrors', false);
      var errorCode = (0, _get3.default)(error, ['response', 'body', statusField], error[statusField]);
      var hideErrorCodes = (0, _get3.default)(error, 'hideErrorCodes', []);
      var isErrorTime = this.lastError !== message || Date.now() - this.lastErrorTime > 3000;
      var isHideError = hideErrors || hidePopup || hideErrorCodes.includes(errorCode);

      if (isErrorTime) {
        this.lastError = message;
        this.lastErrorTime = Date.now();
        if (!isHideError) {
          this.showToast({ type: 'error', message: message });
        }
      }
    }
    /* eslint-enable no-use-before-define */

  }, {
    key: 'checkResponseCode',
    value: function checkResponseCode(_ref6) {
      var response = _ref6.response;
      var statusField = _config2.default.response.statusField;

      if (response[statusField] === _responseCodes2.default.sessionError && this.getUser()) {
        return this.dispatch((0, _auth.logout)());
      }

      return false;
    }
  }, {
    key: 'onSuccess',
    value: function onSuccess(_ref7) {
      var result = _ref7.result;

      var _action$types = (0, _slicedToArray3.default)(this.action.types, 2),
          SUCCESS = _action$types[1];

      this.onResultPopup({ result: result });
      this.promiseStore[SUCCESS] = null;
      var actionParams = this.getActionParams();
      return this.next((0, _extends3.default)({}, actionParams, { result: result, type: SUCCESS }));
    }
  }, {
    key: 'onError',
    value: function onError(_ref8) {
      var error = _ref8.error;

      var _action$types2 = (0, _slicedToArray3.default)(this.action.types, 3),
          FAILURE = _action$types2[2];

      this.onErrorPopup({ error: error });
      this.promiseStore[FAILURE] = null;

      this.checkResponseCode({ response: error });

      console.warn((0, _consoleColor.shellFg)('red') + 'Middleware server request error. Action: ' + FAILURE + (0, _consoleColor.shellReset)(), error);
      return this.next((0, _extends3.default)({}, this.getActionParams(), { error: error, type: FAILURE }));
    }
  }, {
    key: 'abortRequests',
    value: function abortRequests(_ref9) {
      var _this = this;

      var abortKeys = _ref9.abortKeys;

      if (!Array.isArray(abortKeys)) {
        return false;
      }
      abortKeys.map(function (abortKey) {
        if (_this.promiseStore[abortKey]) {
          _this.promiseStore[abortKey].request.abort();
          _this.promiseStore[abortKey] = null;
        }
      });
    }

    // save promise and request in promise store and abort the same previous request

  }, {
    key: 'updatePromiseStore',
    value: function updatePromiseStore(_ref10) {
      var actionResult = _ref10.actionResult;
      var _action = this.action,
          abortable = _action.abortable,
          _action$abort = _action.abort,
          abort = _action$abort === undefined ? [] : _action$abort;

      var abortKeys = [].concat((0, _toConsumableArray3.default)(abort));

      var _action$types3 = (0, _slicedToArray3.default)(this.action.types, 1),
          REQUEST = _action$types3[0];

      if (abortable) {
        abortKeys.push(REQUEST);
      }
      this.abortRequests({ abortKeys: abortKeys });
      this.promiseStore[REQUEST] = actionResult;
    }
  }, {
    key: 'getActionParams',
    value: function getActionParams() {
      var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref11$action = _ref11.action,
          action = _ref11$action === undefined ? this.action : _ref11$action;

      var promise = action.promise,
          abortable = action.abortable,
          abort = action.abort,
          types = action.types,
          actionParams = (0, _objectWithoutProperties3.default)(action, ['promise', 'abortable', 'abort', 'types']); // eslint-disable-line no-unused-vars

      return actionParams;
    }
  }, {
    key: 'middleware',
    value: function middleware() {
      var _this2 = this;

      return function (_ref12) {
        var dispatch = _ref12.dispatch,
            getState = _ref12.getState;
        return function (next) {
          return function (action) {
            if (typeof action === 'function') {
              return action(dispatch, getState);
            } else if (!action.promise) {
              return next(action);
            }

            _this2.setParams({ dispatch: dispatch, getState: getState, action: action, next: next });
            var actionParams = _this2.getActionParams({ action: action });

            var _action$types4 = (0, _slicedToArray3.default)(action.types, 1),
                REQUEST = _action$types4[0];

            next((0, _extends3.default)({}, actionParams, { type: REQUEST }));

            var actionResult = action.promise(_this2.client);
            actionResult.promise.then(function (result) {
              _this2.setParams({ dispatch: dispatch, getState: getState, action: action, next: next });
              return _this2.onSuccess({ result: result });
            }, function (error) {
              _this2.setParams({ dispatch: dispatch, getState: getState, action: action, next: next });
              return _this2.onError({ error: error });
            }).catch(function (error) {
              _this2.setParams({ dispatch: dispatch, getState: getState, action: action, next: next });
              return _this2.onError({ error: error });
            });

            _this2.updatePromiseStore({ actionResult: actionResult });

            return actionResult;
          };
        };
      };
    }
  }]);
  return ClientMiddleware;
}();

exports.default = ClientMiddleware;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/middleware/clientMiddleware.js
// module id = 2233
// module chunks = 1